import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { Container } from '@/components/generals/container'
import { SectionHeading } from '@/components/sections/section-heading'

import { processPhases } from '@/constants/content'

export const ProcessSteps: FC = (): ReactNode => {
    return (
        <section id='faze' aria-labelledby='faze-title' className='relative isolate overflow-hidden bg-ink py-20 text-white lg:py-24'>
            <div
                aria-hidden='true'
                className='blueprint-grid absolute inset-0 -z-10 text-white [mask-image:linear-gradient(to_bottom,black,transparent_80%)]'
            />

            <Container>
                <SectionHeading
                    tone='inverse'
                    title='Realizacija projekta kroz faze'
                    description='Vaš projekat prolazi kroz jasno definisan proces koji garantuje kvalitetan rezultat i Vaše zadovoljstvo.'
                    headingId='faze-title'
                />

                <ol className='mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4'>
                    {processPhases.map((phase, index) => (
                        <li key={phase.title} className='group flex flex-col text-center'>
                            <div className='relative aspect-[4/3] overflow-hidden rounded-md bg-white/5'>
                                <Image
                                    src={phase.image}
                                    alt={phase.imageAlt}
                                    fill
                                    sizes='(min-width: 1280px) 290px, (min-width: 1024px) 25vw, (min-width: 640px) 50vw, 100vw'
                                    className='object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04] motion-reduce:transition-none motion-reduce:group-hover:scale-100'
                                />

                                <span className='absolute top-3 left-3 flex size-8 items-center justify-center rounded-full bg-primary text-xs font-bold text-primary-foreground'>
                                    {index + 1}
                                </span>
                            </div>

                            <h3 className='mt-5 text-lg font-bold tracking-tight sm:text-xl'>
                                {phase.title}
                            </h3>

                            <p className='mx-auto mt-2 max-w-60 text-sm leading-relaxed text-ink-muted'>
                                {phase.description}
                            </p>
                        </li>
                    ))}
                </ol>
            </Container>
        </section>
    )
}
